import { ApexOptions } from 'apexcharts';

import { TFunction } from 'i18next';
import { CreatedVsFixedPerMonthChartData } from 'api/analitics/EncCharts/types';

export const createVsFixEncsPerMonthChartOptions = (data: CreatedVsFixedPerMonthChartData, t: TFunction) => {
  const chartOptions: ApexOptions = {
    series: [
      {
        name: t('ChartsAnalitics.encounters_charts.create_vs_fixed.series.fixed'),
        data: data?.series[1]?.data || [],
      },
      {
        name: t('ChartsAnalitics.encounters_charts.create_vs_fixed.series.created'),
        data: data?.series[0]?.data || [],
      },
    ],
    chart: {
      height: 350,
      type: 'bar',
      stacked: true,
      toolbar: {
        show: true,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        borderRadius: 6,
        dataLabels: {
          total: {
            enabled: true,
            offsetX: 0,
            style: {
              fontSize: '13px',
              fontWeight: 900,
            },
          },
        },
      },
    },
    stroke: {
      width: 1,
      colors: ['#fff'],
    },
    colors: ['#6A37D4', '#EED32E'],
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val.toString();
      },
      style: {
        fontSize: '12px',
      },
    },
    xaxis: {
      title: {
        text: t('ChartsAnalitics.encounters_charts.create_vs_fixed.x_axis_title'),
        style: {
          fontSize: '12px',
        },
      },
      categories: data?.labels || [],
      type: 'category',
      tickPlacement: 'on',
    },
    yaxis: {
      title: {
        text: t('ChartsAnalitics.encounters_charts.create_vs_fixed.y_axis_title'),
        style: {
          fontSize: '12px',
        },
      },
      min: 0,
      stepSize: 1,
      forceNiceScale: true,
      decimalsInFloat: 0,
      labels: {
        formatter: value => Math.floor(value).toString(),
      },
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: function (val) {
          return val.toString();
        },
      },
    },
    legend: {
      show: true,
      position: 'top',
    },
  };

  return chartOptions;
};
